import { render, staticRenderFns } from "./PropriedadesObjeto.vue?vue&type=template&id=30edf250&scoped=true&"
import script from "./PropriedadesObjeto.vue?vue&type=script&lang=js&"
export * from "./PropriedadesObjeto.vue?vue&type=script&lang=js&"
import style0 from "./PropriedadesObjeto.vue?vue&type=style&index=0&id=30edf250&prod&lang=scss&scoped=true&"
import style1 from "./PropriedadesObjeto.vue?vue&type=style&index=1&id=30edf250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30edf250",
  null
  
)

export default component.exports